import { render } from "./pageDesc.vue?vue&type=template&id=50a32f40&scoped=true"
import script from "./pageDesc.vue?vue&type=script&lang=js"
export * from "./pageDesc.vue?vue&type=script&lang=js"

import "./pageDesc.vue?vue&type=style&index=0&id=50a32f40&scoped=true&lang=css"

import exportComponent from "F:\\yiban\\WebProject\\yimeng-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a32f40"]])

export default __exports__